<template>
    <section class="article" v-if="this.$store.state.settings.site_id === 1">
        <div >
            <ul class="list card-dop-sec__nav-line sizes__tabs">


                <li class="sizes__gender-tab list__element card-dop-sec__nav-line-element" @click="tab = 1" :class="tab === 1 ? 'card-dop-sec__nav-line_active':''"> {{trans('Male')}}
                </li>

                <li class="sizes__gender-tab list__element card-dop-sec__nav-line-element" @click="tab = 2" :class="tab === 2 ? 'card-dop-sec__nav-line_active':''"> {{trans('Female')}}
                </li>


            </ul>

            <div class="sizes__gender-tab-content card-dop-sec__tab_active   " :class="tab == 1 ?'sizes__gender-tab-content_active':''"
                 v-if="tab === 1">
                <ul class="list card-dop-sec__nav-line sizes__tabs">

                    <swiper
                        class="swiper-wrapper list bottom-nav-list "
                        :modules="modules"
                        :slides-per-view="8"
                        :space-between="20"
                    >

                        <swiper-slide v-for="male in menu_male.items" style="transform: translate3d(0px, 0px, 0px)">
                            <li class="bottom-nav-list__element"  @click="getSizes(male)">
                                <a class="bottom-nav-list__link">{{ male.name }}</a>
                            </li>
                        </swiper-slide>

                    </swiper>


                </ul>

            </div>

            <div class="sizes__gender-tab-content card-dop-sec__tab_active " v-if="tab === 2" :class="tab == 2 ?'sizes__gender-tab-content_active':''">
                <ul class="list card-dop-sec__nav-line sizes__tabs">

                    <swiper
                        class="swiper-wrapper list bottom-nav-list "
                        :modules="modules"
                        :slides-per-view="8"
                        :space-between="20"
                    >

                        <swiper-slide v-for="male in menu_female.items" style="transform: translate3d(0px, 0px, 0px)">
                            <li class="bottom-nav-list__element"  @click="getSizes(male)">
                                <a class="bottom-nav-list__link">{{ male.name }}</a>
                            </li>
                        </swiper-slide>

                    </swiper>


                </ul>

            </div>

            <div class="sizes__section-content sizes__section-content_active">
                <div  class="size-schema table-size" v-for="size in sizes" :key="size.id">
                    <div  class="table-size__info">
                        <div  class="size-schema__title sec-title">{{size.name}}</div>
                        <div  class="size-schema__table" v-html="size.table">
                        </div>
                        <p  class="table-size__text">{{trans("The dimensions are given in centimeters")}}</p>
                    </div>
                    <div  class="size-schema__image table-size__img">
                        <picture >
                            <source
                                :srcset="size.images.webp"
                                type="image/webp">
                            <img  :src="size.images.jpeg"
                                  :alt="size.name" class="img-element">
                        </picture>
                    </div>
                </div>



            </div>


            <main class="article">

                {{ trans("For complete confidence in the choice of size, you can personally measure a similar thing from your wardrobe") }}.
                <strong>{{ trans("Spread it out on a flat surface") }}.</strong>
                {{ trans("Use a centimeter or tape measure to measure the dimensions as shown in the diagram and check the size grid of the Bat Norton clothing model you need")}}.
            </main>


        </div>

    </section>
    <section class="article" v-if="this.$store.state.settings.site_id === 2">
        <SizeEn/>

    </section>
</template>

<script>
import {Navigation, Pagination, Scrollbar, A11y} from 'swiper/modules';

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';

import SizeEn from './en/sizes.vue'
export default {
    components:{
        Swiper,
        SwiperSlide,SizeEn

    },
    name: "sizes",
    data(){
        return{
            tab: 1,
            modules: [Navigation],
            menu_male:[],
            menu_female:[],
            sizes:[],
        }
    },
    mounted() {
        this.getMenus()
    },
    methods:{

        async getSizes(male){
            if(this.$store.state.sizes.find(item => item.id == male.id)){
                this.sizes = this.$store.state.sizes.find(item => item.id == male.id).items
            }else{
                await  axios.get('/api/v1/get-sizes', {
                    params:this.setParam(male)})
                    .then(data =>{
                        this.sizes = data.data
                        this.$store.state.sizes.push({id:male.id,items:data.data})

                    })
            }



        },
        async getMenus(){
            await  axios.get('/api/v1/menus-sizes', {
                params:this.setParam()})
                .then(data =>{
                    this.menu_male = data.data[0];
                    this.menu_female = data.data[1];

                }, err => {
                    this.$router.push('/404')
                })

        },

    }
}
</script>

<style scoped>
.sizes__tabs .swiper-slide {
    width: unset !important;
}
</style>
